<template>
  <BaseRoundButton
    @click.native="toggle()"
    :size="45"
    :tooltip-text="tooltipText"
    class="beacon"
    icon="life-buoy"
    ref="beaconIcon"
    is-white
  />
</template>

<script>
import BaseRoundButton from '@/components/base/BaseRoundButton';
import { Beacon, beaconStatus } from '@/plugins/beacon';

export default {
  name: 'Beacon',
  components: {
    BaseRoundButton,
  },
  props: {
    noTooltip: Boolean,
  },
  computed: {
    isOpen() {
      return beaconStatus.opened;
    },
    tooltipText() {
      return this.noTooltip ? '' : this.$t('navigation-bar.beacon');
    },
  },
  methods: {
    toggle() {
      this.$track.contactUs('beacon');
      Beacon.toggle();
      Beacon.navigate('answers');
    },
  },
  watch: {
    isOpen() {
      const el = this.$refs.beaconIcon.$el;
      if (this.isOpen) {
        el.classList.add('opened');
      } else {
        el.classList.remove('opened');
      }
    },
  },
};
</script>

<style lang="scss">
.beacon {
  align-items: center;
  background: none;
  border: none;
  border-radius: $border-radius-round;
  color: $color-normal;
  cursor: pointer;
  display: flex;
  justify-content: center;
  outline: none;
  transition: color 200ms ease;
  height: 50px;
  width: 50px;

  &:hover,
  &:active {
    color: $color-accent;
  }

  &:focus {
    box-shadow: $shadow-focus-outline;
  }

  .feather {
    height: 24px;
    width: 24px;
  }
}
.opened {
  color: $color-accent !important;
}
</style>
